import { getTomorrow, thirtyDaysFromNow } from 'utils/util';
import { USDollar, toTitleCase } from 'utils/format';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from 'GlobalContext';
import { useContext } from 'react';
import { formatCurrency } from 'utils/format';
import { shadeColor } from 'utils/util';

export function AccountingL2ByAccount(props) {
    const navigate = useNavigate();
    const { setManageRecordTab, setManageRecordId } = useContext(GlobalContext);
    // payout entries group by payment company -> account id
    const {
        payouts,
        accountId2accountName,
        accountId,
        isTop,
        accountId2Investors,
        transactionId2Status,
        timezoneOffset,
        handleStatusChange,
        accountId2Currency,
        accountBgColor,
    } = props;
    const { payoutTableColumnsToShow, payoutsColumns, payoutTableWidth } =
        useContext(GlobalContext);

    const backgroundColors = [accountBgColor, shadeColor(accountBgColor, 2.5)];

    function MainItem(props) {
        const { columnName, columnText, background } = props;
        return (
            <>
                {payoutTableColumnsToShow[columnName] && (
                    <div
                        style={{
                            width: `${payoutsColumns[columnName]}px`,
                            textAlign: 'center',
                            alignContent: 'center',
                            background,
                        }}
                    >
                        {columnText}
                    </div>
                )}
            </>
        );
    }

    return (
        <>
            {' '}
            {payouts.length > 0 && accountId2Investors[accountId] && (
                <div
                    style={{
                        display: 'flex',
                        background: accountBgColor,
                        // borderTop: isTop ? '' : '1px solid black',
                    }}
                >
                    {payoutTableColumnsToShow['Investment Entity'] && (
                        <div
                            style={{
                                width: `${payoutsColumns['Investment Entity']}px`,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                background: accountBgColor,
                            }}
                        >
                            <div
                                style={{
                                    color: 'blue',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    height: 'fit-content',
                                }}
                                onClick={() => {
                                    navigate('/recordManager');
                                    setManageRecordTab('Investment Entities');
                                    setManageRecordId(accountId);
                                    // setAccountIdToView(accountId);
                                }}
                            >
                                {accountId2accountName[accountId]}
                            </div>
                            {/* <div>
                            {accountId2Currency[accountId] === 'USD'
                                ? '$ USD'
                                : '￥CNY'}
                        </div> */}
                        </div>
                    )}

                    {payoutTableColumnsToShow['Investor'] && (
                        <div
                            style={{
                                width: `${payoutsColumns['Investor']}px`,
                                textAlign: 'center',
                                background: accountBgColor,
                            }}
                        >
                            {accountId2Investors[accountId].map(
                                (investor, id) => (
                                    <div key={id}>
                                        <div
                                            style={{
                                                color: 'blue',
                                                textDecoration: 'underline',
                                                cursor: 'pointer',
                                                height: 'fit-content',
                                            }}
                                            onClick={() => {
                                                navigate('/recordManager');
                                                setManageRecordTab('Investors');
                                                setManageRecordId(
                                                    investor.investor_id
                                                );
                                                // setAccountIdToView(accountId);
                                            }}
                                        >
                                            {investor.legal_name}
                                        </div>
                                        <div style={{ fontSize: '10px' }}>
                                            {investor.email}
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    )}

                    <div style={{ alignContent: 'center' }}>
                        {payouts
                            .sort((a, b) => {
                                if (a.fund_name !== b.fund_name) {
                                    if (a.fund_name > b.fund_name) {
                                        return 1;
                                    } else {
                                        return -1;
                                    }
                                }
                                if (a.timestamp !== b.timestamp) {
                                    if (a.timestamp > b.timestamp) {
                                        return 1;
                                    } else {
                                        return -1;
                                    }
                                }
                                if (a.transaction_id > b.transaction_id) {
                                    return 1;
                                }
                                return -1;
                            })
                            .map((payout, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: 'flex',
                                        // borderTop:
                                        //     idx === 0 ? '' : '1px solid black',
                                    }}
                                >
                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Fund'}
                                        columnText={payout.fund_name}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Start Date'}
                                        columnText={payout.funding_receipt_date.slice(
                                            0,
                                            10
                                        )}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'End Date'}
                                        columnText={payout.actual_redemption_date.slice(
                                            0,
                                            10
                                        )}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Currency'}
                                        columnText={payout.currency}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Frequency'}
                                        columnText={toTitleCase(
                                            payout.payout_frequency
                                        )}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Interest'}
                                        columnText={`${
                                            payout.overall_interest
                                                ? Math.max(
                                                      payout.overall_interest,
                                                      payout.annual_interest_rate
                                                  )
                                                : payout.annual_interest_rate
                                        }%`}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Invested Amount'}
                                        columnText={formatCurrency(
                                            payout.invested_amount,
                                            payout.currency
                                        )}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Account Balance'}
                                        columnText={formatCurrency(
                                            payout.account_balance,
                                            payout.currency
                                        )}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Amount'}
                                        columnText={formatCurrency(
                                            payout.transaction_amount,
                                            payout.currency
                                        )}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Type'}
                                        columnText={toTitleCase(
                                            payout.transaction_type
                                        )}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Next Payment Date'}
                                        columnText={payout.timestamp}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Next Payment Due'}
                                        columnText={getTomorrow(
                                            payout.timestamp
                                        )}
                                    />

                                    <MainItem
                                        background={backgroundColors[idx % 2]}
                                        columnName={'Status'}
                                        columnText={toTitleCase(
                                            transactionId2Status[
                                                payout.transaction_id
                                            ]
                                        )}
                                    />

                                    {payoutTableColumnsToShow['Pay'] && (
                                        <div
                                            style={{
                                                width: '80px',
                                                textAlign: 'center',
                                                alignContent: 'center',
                                                background:
                                                    backgroundColors[idx % 2],
                                            }}
                                        >
                                            {transactionId2Status[
                                                payout.transaction_id
                                            ].toLowerCase() !== 'reinvest' &&
                                                new Date(
                                                    payout.timestamp +
                                                        timezoneOffset
                                                ) <= thirtyDaysFromNow() && (
                                                    <button
                                                        style={{
                                                            background:
                                                                transactionId2Status[
                                                                    payout
                                                                        .transaction_id
                                                                ].toLowerCase() ===
                                                                'unpaid'
                                                                    ? '#10b981'
                                                                    : '#ef4444', //"rgb(17 32 86)",
                                                            color: 'white',
                                                            borderRadius: '5px',
                                                        }}
                                                        onClick={() =>
                                                            handleStatusChange(
                                                                payout,
                                                                accountId2Investors[
                                                                    accountId
                                                                ].map(
                                                                    (
                                                                        investor
                                                                    ) =>
                                                                        investor.email
                                                                ),
                                                                accountId2accountName[
                                                                    accountId
                                                                ],
                                                                payout.transaction_type
                                                            )
                                                        }
                                                    >
                                                        {transactionId2Status[
                                                            payout
                                                                .transaction_id
                                                        ].toLowerCase() ===
                                                        'unpaid'
                                                            ? 'Pay'
                                                            : 'Unpay'}
                                                    </button>
                                                )}
                                        </div>
                                    )}
                                </div>
                            ))}
                    </div>
                </div>
            )}
        </>
    );
}
